import { Cookies } from 'react-cookie';

import { IDigestReportResponse } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface DigestReportDataProps {
  slug: string;
  id: string;
}

export const getDigestReportsId = async ({ slug, id }: DigestReportDataProps): Promise<IDigestReportResponse> => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.get<IDigestReportResponse>(`/objects/${slug}/technician-digests/${id}/`, {
    headers: {
      Authorization: token,
    },
  });

  return response.data;
};
